<template>
    <div>        
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h3>Reports</h3>
            <div>
                <button @click="addReport" class="btn btn-border">+ NEW REPORT</button>
            </div>
        </div>
        <div class="reportListWrap">
            <div v-for="(report, key) in reports" :key="report.id" class="report_item black_block black_block_done p-0 mt-3">
                <div class="report_item_left">
                    <h6>{{report.name}}</h6>                
                </div>
                <div class="report_item_right">
                    <a :href="`/reports/${report.id}?export=1`">EXPORT</a>
                    <a :href="`/reports/${report.id}`">SHOW REPORT</a>
                    <div class="dotscontrol" >
                        <div class="dotscontrol_dots" type="button" :id="`dropdownMenuButton${key}`" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="dotscontrol_dots__span"></span>
                        </div>
                        <ul class="dropdown-menu" :aria-labelledby="`dropdownMenuButton${key}`">
                            <li><a @click="editReport(report)" class="dropdown-item">EDIT</a></li>
                            <li> <a @click="deleteReport(report.id)" class="dropdown-item" >DELETE</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import {bus} from '../../bus';
import hrdate from "../hrdate";
import Dotscontrol from "../Dotscontrol";
export default {
    data(){
        return{
            reports: [],
            model_category: 'all',
            change_category: [],
            sort: 'id',
            sorttype: 'desc',
            model_countitempage: 15,
            step: 10,            
            page: 1,
            waitingForAnResponse: false,
            isLoad: false,
        }
    },
    methods: {
         addReport(){
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formreport',
                'crud': 'create',
                'title_form': 'Create new report',
                'report': {
                    "name": "",
                    "video_id": [],
                    "person_id": [],
                    "date_begin": "",
                    "date_end": ""
                }
            })
        },
        editReport(report){            
            bus.$emit('openpopup', {
                'open': true,
                'type': 'formreport',
                'crud': 'update',
                'title_form': 'Update report',
                'report': report,
                'addPopupClass': 'editreport'
            })
        },
        deleteReport(id){
            axios.delete(`/reports/${id}`
            ).then((responce)=>{
                console.log('delete report', responce);
                this.getResults();
                this.model_all = false;
            }).catch(function(){
                console.log('FAILURE!!');
            });
        },
        scroll() {               
            let listReports = document.querySelector('.reportListWrap')
            
            listReports.onscroll = () => {
                /*
                    clientHeight высота содержимого вместе с полями padding, но без полосы прокрутки.
                    offsetHeight «внешняя» высота блока, включая рамки.
                    scrollHeight полная внутренняя высота, включая прокрученную область.
                */
                
                let bottomOfListReports =
                listReports.scrollTop + listReports.clientHeight + 10 >=
                listReports.scrollHeight;

                /* listReports.scrollHeight > 40 because otherwise it reacts to decreasing height when clearing the list
                    40 random approximate number */
                if (
                    bottomOfListReports && listReports.scrollHeight > 40
                    && 
                    !this.waitingForAnResponse
                ) {
                    
                    this.loadingDataFromServer()
                }
            };
        }, 
        loadingDataFromServer() {                
            this.waitingForAnResponse = true    // flag for not reppeat before respons from server
            this.isLoad = true  // enable "Loading..." down list
            
            this.model_countitempage += this.step;
            console.log('this.step', this.step);
            console.log('this.model_countitempage', this.model_countitempage);                
            let response = this.getResults();

            this.isLoad = false
        },
        getResults(page = 1) {
            const url = `/reports/`;
            const params = {                
                page: page,
                countitempage: this.model_countitempage,
                sort: this.sort,
                sorttype: this.sorttype,
                find: this.model_find,
                short: 'y'
            }

            console.log('params', params);

            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }
            ).then((response) => {                
                this.reports = response.data.data;
                console.log( 'this.reports.length', this.reports.length );
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        },
    },
    mounted(){
        this.getResults();
        this.scroll();
        bus.$on('updatereports', () => {
            this.getResults();
        });
    },
    computed: {},
    components: {
        hrdate,
        Dotscontrol
    }
}
</script>

<style lang="scss" scoped>
.reportListWrap {
    overflow: auto;
    height: 1140px;
}
.report_item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: .7rem;
    background: #000B41 !important;
    a{
        color: #fff;
        font-size: .8rem;
        text-decoration: none;
    }
    a + a{
        margin: 0 .5rem;
    }
    .report_item_left{
        display: flex;
        align-items: center;
        h6{
            margin-bottom: 0;
            margin-right: 1rem;
        }
    }
    .report_item_right{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}
</style>
